import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import userGoogleBilling from '~/pages/UserSaga/UserGoogleBilling/userGoogleBilling.api';
import { requestStarted, requestFinished } from '~/stores/redux/common/loadingSlice';
import { handleThunkException } from '~/services/thunk.service';
import { PAGINATION_PER_PAGE } from '~/config/constants';

export const fetchUserGoogleBillingApi = createAsyncThunk('user/fetchUserGoogleBillingApi', async (params, { dispatch }) => {
    try {
        dispatch(requestStarted());
        const data = await userGoogleBilling.getAll(params);
        if (data) {
            dispatch(getRowsPaginated(data.rows));
            dispatch(getTotalRowsNumber(data.totalRows));
            dispatch(changePerPage(params.perPage));
            dispatch(changePage(params.page));
            dispatch(requestFinished());
        }
    } catch (error) {
        handleThunkException(error, dispatch);
    }
});

export const userGoogleBillingSlice = createSlice({
    name: 'userGoogleBilling',
    initialState: {
        rows: [],
        totalRows: 0,
        perPage: PAGINATION_PER_PAGE,
        page: 1,
    },
    reducers: {
        getRowsPaginated(state, { payload }) {
            return {
                ...state,
                rows: payload,
            };
        },
        getTotalRowsNumber(state, { payload }) {
            return {
                ...state,
                totalRows: payload,
            };
        },
        changePerPage(state, { payload }) {
            return {
                ...state,
                perPage: payload,
            };
        },
        changePage(state, { payload }) {
            return {
                ...state,
                page: payload,
            };
        },
    },
});

export const { getRowsPaginated, getTotalRowsNumber, changePerPage, changePage } = userGoogleBillingSlice.actions;